import React, { useEffect } from "react";
import TransferenciasCuentasPrymeraHeader from "./TransferenciasCuentasPrymeraHeader";
import {
  Container,
  Header,
  Form,
  Button,
  Grid,
  Icon,
  Label,
} from "semantic-ui-react";
import { useState } from "react";
import {
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_INICIAL,
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_VALIDACION,
  FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_PROCESADO,
  LONGITUD_MAXIMA_IMPORTE,
  LONGITUD_MINIMA_CUENTA_AHORROS_PRYMERA,
  LONGITUD_MAXIMA_CUENTA_AHORROS_PRYMERA,
  RESPONSE_MESSAGE_CODE_SUCCESS,
  LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
  LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR,
  CODIGO_TIPO_PROCESO_AUDITORIA_TRANSFERENCIAS_OTRAS_CUENTAS,
  MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR,
  LABEL_INGRESE_CLAVE_DOBLE_FACTOR,
} from "../../../../app/infrastructure/appConstants";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { getCuentasOperacionesPrymera } from "../../../../app/store/actions/cuentaActions";
import {
  generarClaveDobleFactor,
  validarClaveDobleFactor,
} from "../../../../app/store/actions/transactionalActions";
import { verificarDisponibilidadPago } from "../../../../app/store/actions/pagoActions";
import {
  transferenciaCuentasPrymeraValidar,
  transferenciaCuentasPrymeraConfirmar,
} from "../../../../app/store/actions/transferenciaActions";
import { createOptionsCuentaTransferencias } from "../../../../app/util/optionsUtils";
import { connect } from "react-redux";
import { Form as FinalForm, Field } from "react-final-form";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthBetween,
} from "revalidate";
import {
  isCuentaDestinoDiferente,
  isGreaterThanOrEqual,
} from "../../../../app/util/revalidateUtils";
import { tipoMonedaOptions } from "../../../../app/config/data/options";
import NumberInput from "../../../../app/common/form/NumberInput";
import PropTypes from "prop-types";
import TransferenciasCuentasPrymeraResumen from "./TransferenciasCuentasPrymeraResumen";
import { Link } from "react-router-dom";
import TextInput from "../../../../app/common/form/TextInput";
import { normalizeNumero } from "../../../../app/util/finalFormUtils";
import { toast } from "react-toastify";
import {
  MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
  MESSAGE_TRANSFERENCIA_PRYMERA_CUENTA_ORIGEN,
  TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL,
} from "../../../../app/util/messageUtils";
import DisponibilidadOperacionesMessage from "../../../../app/common/messages/DisponibilidadOperacionesMessage";
import { resetScroll } from "../../../../app/util/JsUtils";
import ModalClaveDobleFactor from "../../../../app/common/modals/ModalClaveDobleFactor";
import {
  buildGenerarClaveDobleFactorRequest,
  buildValidarClaveDobleFactorRequest,
} from "../../../../app/util/transactionalUtils";

const actions = {
  getCuentasOperacionesPrymera,
  verificarDisponibilidadPago,
  transferenciaCuentasPrymeraValidar,
  transferenciaCuentasPrymeraConfirmar,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
};
const mapState = (state) => ({
  cuentasOperacionesPrymera: state.cuentaReducer.cuentasOperacionesPrymera,
  loadingCuentasOperacionesPrymera:
    state.cuentaReducer.loadingCuentasOperacionesPrymera,
  currentUser: state.auth.currentUser,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  loadingTransferenciaCuentasPrymeraValidar:
    state.transferenciaReducer.loadingTransferenciaCuentasPrymeraValidar,
  loadingTransferenciaCuentasPrymeraConfirmar:
    state.transferenciaReducer.loadingTransferenciaCuentasPrymeraConfirmar,
  loadingGenerarClaveDobleFactor:
    state.transactionalReducer.loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor:
    state.transactionalReducer.loadingValidarClaveDobleFactor,
  claveDobleFactorUsuario: state.transactionalReducer.claveDobleFactorUsuario,
});

const TransferenciasCuentasPrymeraPage = ({
  cuentasOperacionesPrymera,
  loadingCuentasOperacionesPrymera,
  getCuentasOperacionesPrymera,
  currentUser,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  transferenciaCuentasPrymeraValidar,
  transferenciaCuentasPrymeraConfirmar,
  loadingTransferenciaCuentasPrymeraValidar,
  loadingTransferenciaCuentasPrymeraConfirmar,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
  claveDobleFactorUsuario,
  loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor,
}) => {
  //Constantes
  const generarClaveDobleFactorRequest = buildGenerarClaveDobleFactorRequest(
    CODIGO_TIPO_PROCESO_AUDITORIA_TRANSFERENCIAS_OTRAS_CUENTAS,
    claveDobleFactorUsuario
  );

  //effects
  useEffect(() => {
    if (currentUser?.username) {
      getCuentasOperacionesPrymera();
    }
  }, [getCuentasOperacionesPrymera, currentUser]);

  //states
  const [
    faseTransferenciaCuentasPrymera,
    setFaseTransferenciaCuentasPrymera,
  ] = useState(FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_INICIAL);
  const [cuentaOrigen, setCuentaOrigen] = useState(null);
  const [codigoMonedaCuentaOrigen, setCodigoMonedaCuentaOrigen] = useState(
    null
  );
  // const [
  //   saldoDisponibleCuentaOrigen,
  //   setSaldoDisponibleCuentaOrigen,
  // ] = useState(null);
  const [cuentaDestino, setCuentaDestino] = useState(null);

  const [codigoMoneda, setCodigoMoneda] = useState(null);
  const [importeTransferencia, setImporteTransferencia] = useState(null);
  const [aplicaTipoCambio, setAplicaTipoCambio] = useState(false);
  const [importeValidado, setImporteValidado] = useState(null);
  const [itfValidado, setItfValidado] = useState(null);
  const [tipoCambioValidado, setTipoCambioValidado] = useState(null);
  const [nombreTitularValidado, setNombreTitularValidado] = useState(null);
  const [claveDobleFactor, setClaveDobleFactor] = useState(null);
  const [
    flagGeneracionExitosaClaveDobleFactor,
    setGeneracionExitosaClaveDobleFactor,
  ] = useState(false);
  const [
    msgValidacionClaveDobleFactor,
    setMsgValidacionClaveDobleFactor,
  ] = useState(null);
  const [
    openModalGenerarClaveDobleFactor,
    setOpenModalGenerarClaveDobleFactor,
  ] = useState(false);
  const [importeTransferirValidado, setImporteTransferirValidado] = useState(
    null
  );
  const [monedaTransferirValidado, setMonedaTransferirValidado] = useState(
    null
  );
  const [importeDebitarValidado, setImporteDebitarValidado] = useState(null);
  const [monedaDebitarValidado, setMonedaDebitarValidado] = useState(null);
  //Options
  const cuentasOptions = createOptionsCuentaTransferencias(
    cuentasOperacionesPrymera
  );
  //validates
  const validate = combineValidators({
    cuentaRetiro: composeValidators(
      isRequired({ message: "Debe seleccionar la cuenta origen" })
    )(),
    cuentaDeposito: composeValidators(
      isRequired({ message: "Debe ingresar la cuenta destino" }),
      isCuentaDestinoDiferente(cuentaOrigen)({
        message: `La cuenta destino tiene que ser diferente a la cuenta origen`,
      }),
      hasLengthBetween(
        LONGITUD_MINIMA_CUENTA_AHORROS_PRYMERA,
        LONGITUD_MAXIMA_CUENTA_AHORROS_PRYMERA
      )({
        message: "Número de cuenta no válida",
      })
    )(),
    codigoMoneda: composeValidators(
      isRequired({ message: "Debe seleccionar la moneda" })
    )(),
    importe: composeValidators(
      isRequired({ message: "Importe es requerido" }),
      isGreaterThanOrEqual(1)({
        message: `El importe tiene que ser mayor a 0`,
      })
    )(),
  });
  //
  const validateConfirmacionTransferencia = combineValidators({
    claveDobleFactor: composeValidators(
      isRequired({ message: MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR }),
      hasLengthBetween(
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR
      )({
        message: MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
      })
    )(),
  });

  //business logic
  //Metodo que permite validar la transferencia
  const submitContinuar = async (values) => {
    //Verificando disponibilidad de pago
    const response = await verificarDisponibilidadPago();
    if (response && response.data && response.data.disponible === true) {
      const responseValidacion = await transferenciaCuentasPrymeraValidar({
        ...values,
      });
      if (responseValidacion && responseValidacion.data) {
        try {
          //Generando clave doble factor
          const response = await generarClaveDobleFactor(
            generarClaveDobleFactorRequest
          );
          //end
          if (response && response.code === RESPONSE_MESSAGE_CODE_SUCCESS) {
            setImporteValidado(importeTransferencia);
            setItfValidado(responseValidacion.data.itfRetiro);
            setTipoCambioValidado(responseValidacion.data.tipoCambio);
            setNombreTitularValidado(
              responseValidacion.data.nombreTitularDeposito
            );
            setGeneracionExitosaClaveDobleFactor(true);
            //Validar si se va considerar el codigo de moneda de la cuenta destino una vez validada
            const codigoMonedaDeposito =
              responseValidacion.data.codigoMonedaTransferir;
            //si las cuentas tienen distintos tipo de moneda => aplica tipo de cambio
            setAplicaTipoCambio(
              codigoMonedaCuentaOrigen !== codigoMonedaDeposito
            );
            setMonedaDebitarValidado(
              responseValidacion.data.codigoMonedaRetiro
            );
            setImporteDebitarValidado(responseValidacion.data.importeRetiro);
            setMonedaTransferirValidado(
              responseValidacion.data.codigoMonedaTransferir
            );
            setImporteTransferirValidado(
              responseValidacion.data.importeTransferir
            );
            //fase validacion
            setFaseTransferenciaCuentasPrymera(
              FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_VALIDACION
            );
            resetScroll();
          }
        } catch (error) {
          if (error && error.data && error.data.status !== 401) {
            toast.error(error.data.message);
          }
        }
      }
    }
  };

  //Metodo que permite reiniciar algunos valores cuando se regresa en la transferencia
  const handleAtras = () => {
    setImporteValidado(null);
    setItfValidado(null);
    setTipoCambioValidado(null);
    setAplicaTipoCambio(false);
    setNombreTitularValidado(null);
    setClaveDobleFactor(null);
    setGeneracionExitosaClaveDobleFactor(false);
    setMsgValidacionClaveDobleFactor(null);
    setMonedaDebitarValidado(null);
    setImporteDebitarValidado(null);
    setMonedaTransferirValidado(null);
    setImporteTransferirValidado(null);
    //fase inicio
    setFaseTransferenciaCuentasPrymera(
      FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_INICIAL
    );
  };

  const submitConfirmarTransferencia = async (values) => {
    //Validando Clave doble factor
    let responseValidacionClaveDobleFactor;
    try {
      responseValidacionClaveDobleFactor = await validarClaveDobleFactor(
        buildValidarClaveDobleFactorRequest(
          claveDobleFactorUsuario,
          claveDobleFactor
        )
      );
    } catch (error) {
      if (error && error.data && error.data.status !== 401) {
        const msgValidacion = error.data.message;
        setMsgValidacionClaveDobleFactor(msgValidacion);
        setGeneracionExitosaClaveDobleFactor(false);
        setOpenModalGenerarClaveDobleFactor(true);
        setClaveDobleFactor(null);
      }
    }
    //end
    if (
      responseValidacionClaveDobleFactor &&
      responseValidacionClaveDobleFactor.code === RESPONSE_MESSAGE_CODE_SUCCESS
    ) {
      //Enviando data para transaccion
      const request = {
        cuentaRetiro: cuentaOrigen,
        cuentaDeposito: cuentaDestino,
        importe: importeTransferencia,
        codigoMoneda,
      };
      const responseConfirmacion = await transferenciaCuentasPrymeraConfirmar(
        request
      );
      if (
        responseConfirmacion &&
        responseConfirmacion.data &&
        responseConfirmacion.data.resultado === true
      ) {
        setFaseTransferenciaCuentasPrymera(
          FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_PROCESADO
        );
        resetScroll();
      }
    }
  };

  //return
  if (loadingCuentasOperacionesPrymera)
    return (
      <LoadingComponent content="Cargando cuentas operaciones prymera..." />
    );
  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;
  if (loadingTransferenciaCuentasPrymeraValidar)
    return <LoadingComponent content="Transferencia validar..." />;
  if (loadingTransferenciaCuentasPrymeraConfirmar)
    return <LoadingComponent content="Transferencia confirmar..." />;
  if (loadingGenerarClaveDobleFactor)
    return <LoadingComponent content="Generar Clave ..." />;
  if (loadingValidarClaveDobleFactor)
    return <LoadingComponent content="Validar Clave ..." />;
  return (
    <>
      <Container className="containerPrincipal">
        {faseTransferenciaCuentasPrymera ===
        FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_INICIAL ? (
          <>
            <TransferenciasCuentasPrymeraHeader />
            <FinalForm
              onSubmit={async (values) => {
                submitContinuar(values);
              }}
              initialValues={{
                cuentaRetiro: cuentaOrigen,
                cuentaDeposito: cuentaDestino,
                codigoMoneda: codigoMoneda,
                importe: importeTransferencia,
              }}
              validate={validate}
              render={({ handleSubmit, submitting, invalid }) => (
                <Form
                  onSubmit={handleSubmit}
                  error
                  style={{ marginTop: "2.5em" }}
                >
                  <Header
                    as="h4"
                    color="blue"
                    content="Selecciona la cuenta origen"
                  />
                  <Field
                    name="cuentaRetiro"
                    component={SelectedInput}
                    placeholder="Selecciona la cuenta origen"
                    options={cuentasOptions}
                    handleOnChange={(value) => {
                      setCuentaOrigen(value);
                      if (
                        value &&
                        cuentasOperacionesPrymera &&
                        cuentasOperacionesPrymera.length > 0
                      ) {
                        const cuenta = cuentasOperacionesPrymera.filter(
                          (c) => c.numeroCuenta === value
                        )[0];
                        // setSaldoDisponibleCuentaOrigen(cuenta.saldoDisponible);
                        setCodigoMonedaCuentaOrigen(cuenta.codigoMoneda);
                        setCodigoMoneda(cuenta.codigoMoneda);
                      }
                    }}
                  />{" "}
                  <Label color="blue" tag size="medium">
                    {MESSAGE_TRANSFERENCIA_PRYMERA_CUENTA_ORIGEN}
                  </Label>
                  <Header
                    as="h4"
                    color="blue"
                    content="Ingresa la cuenta destino"
                  />
                  <Field
                    name="cuentaDeposito"
                    component={TextInput}
                    placeholder="Ingresa la cuenta destino"
                    parse={normalizeNumero}
                    maxLength={LONGITUD_MAXIMA_CUENTA_AHORROS_PRYMERA}
                    handleOnChange={(value) => {
                      setCuentaDestino(normalizeNumero(value));
                    }}
                  />
                  <Header as="h4" color="blue" content="Selecciona la moneda" />
                  <Field
                    name="codigoMoneda"
                    component={SelectedInput}
                    placeholder="Selecciona la moneda"
                    options={tipoMonedaOptions}
                    handleOnChange={(value) => {
                      setCodigoMoneda(value);
                    }}
                    disabled={true}
                  />
                  {codigoMonedaCuentaOrigen &&
                    codigoMoneda &&
                    codigoMonedaCuentaOrigen !== codigoMoneda && (
                      <Label color="blue" tag size="medium">
                        {TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL}
                      </Label>
                    )}
                  <Header as="h4" color="blue" content="Ingresa el importe" />
                  <Field
                    name="importe"
                    component={NumberInput}
                    placeholder="Ingresa el importe"
                    handleOnChange={(value) => {
                      setImporteTransferencia(Number(value));
                    }}
                    maxLength={LONGITUD_MAXIMA_IMPORTE}
                    disabled={!cuentaOrigen}
                  />
                  <Container textAlign="center">
                    <Button
                      content="Continuar"
                      disabled={invalid}
                      loading={submitting}
                      style={{ minWidth: "12em", maxWidth: "15em" }}
                      color="yellow"
                      size="large"
                    />
                  </Container>
                </Form>
              )}
            />
          </>
        ) : faseTransferenciaCuentasPrymera ===
          FASE_TRANSFERENCIA_ENTRE_CUENTAS_PRYMERA_VALIDACION ? (
          <>
            <TransferenciasCuentasPrymeraHeader />
            <DisponibilidadOperacionesMessage />
            <Header
              as="h4"
              color="blue"
              content="Revisa los datos y confirma la transferencia"
            />
            <TransferenciasCuentasPrymeraResumen
              cuentaOrigen={cuentaOrigen}
              cuentaDestino={cuentaDestino}
              aplicaTipoCambio={aplicaTipoCambio}
              tipoCambio={tipoCambioValidado}
              itfTransferencia={itfValidado}
              codigoMonedaTransferencia={codigoMoneda}
              importeTotalTransferir={importeTransferencia}
              importeValidado={importeValidado}
              nombreTitularDestino={nombreTitularValidado}
              importeDebitarValidado={importeDebitarValidado}
              monedaDebitarValidado={monedaDebitarValidado}
              importeTransferirValidado={importeTransferirValidado}
              monedaTransferirValidado={monedaTransferirValidado}
            />
            <br />
            <FinalForm
              onSubmit={async (values) => {
                submitConfirmarTransferencia(values);
              }}
              initialValues={{
                claveDobleFactor: claveDobleFactor,
              }}
              validate={validateConfirmacionTransferencia}
              render={({ handleSubmit, invalid }) => (
                <Form onSubmit={handleSubmit} error>
                  <Header
                    as="h4"
                    color="blue"
                    content={LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR}
                    textAlign="left"
                  />
                  <Field
                    name="claveDobleFactor"
                    component={TextInput}
                    placeholder={LABEL_INGRESE_CLAVE_DOBLE_FACTOR}
                    maxLength={LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR}
                    parse={normalizeNumero}
                    handleOnChange={(value) => {
                      setClaveDobleFactor(normalizeNumero(value));
                    }}
                  />
                  <br />
                  <Grid>
                    <Grid.Row>
                      <Grid.Column
                        computer={4}
                        largeScreen={4}
                        mobile={7}
                        tablet={6}
                      >
                        <Button
                          fluid
                          content="Atrás"
                          color="blue"
                          size="large"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAtras();
                          }}
                        />
                      </Grid.Column>
                      <Grid.Column
                        computer={8}
                        largeScreen={8}
                        mobile={2}
                        tablet={4}
                      />
                      <Grid.Column
                        computer={4}
                        largeScreen={4}
                        mobile={7}
                        tablet={6}
                      >
                        <Button
                          content="Confirmar"
                          disabled={
                            invalid && flagGeneracionExitosaClaveDobleFactor
                          }
                          fluid
                          color="yellow"
                          size="large"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form>
              )}
            />
          </>
        ) : (
          <>
            <Container style={{ width: "65%" }} textAlign="center">
              <br />
              <Icon name="check circle outline" color="yellow" size="huge" />
              <Header as="h1" color="blue" size="huge">
                Se realizó exitosamente tu transferencia
              </Header>
              <Header as="h4" color="blue" size="tiny">
                Te enviamos un correo con el detalle de la transferencia.
              </Header>
              <TransferenciasCuentasPrymeraResumen
                cuentaOrigen={cuentaOrigen}
                cuentaDestino={cuentaDestino}
                aplicaTipoCambio={aplicaTipoCambio}
                tipoCambio={tipoCambioValidado}
                itfTransferencia={itfValidado}
                codigoMonedaTransferencia={codigoMoneda}
                importeTotalTransferir={importeTransferencia}
                importeValidado={importeValidado}
                nombreTitularDestino={nombreTitularValidado}
                transferenciaExitosa={true}
                importeDebitarValidado={importeDebitarValidado}
                monedaDebitarValidado={monedaDebitarValidado}
                importeTransferirValidado={importeTransferirValidado}
                monedaTransferirValidado={monedaTransferirValidado}
              />
              <br />
              <Grid stackable>
                <Grid.Row>
                  <Grid.Column
                    computer={8}
                    largeScreen={8}
                    mobile={8}
                    tablet={8}
                  >
                    <Button
                      as={Link}
                      to="/transferencias"
                      color="blue"
                      fluid
                      size="large"
                      content="Nueva transferencia"
                    />
                  </Grid.Column>
                  <Grid.Column
                    computer={8}
                    largeScreen={8}
                    mobile={8}
                    tablet={8}
                    textAlign="right"
                  >
                    <Button
                      to="/cuentas"
                      as={Link}
                      color="yellow"
                      size="large"
                      fluid
                      content="Ir a mis cuentas"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </>
        )}
      </Container>
      <ModalClaveDobleFactor
        openModel={openModalGenerarClaveDobleFactor}
        generarClaveDobleFactorRequest={generarClaveDobleFactorRequest}
        msgValidacionClaveDobleFactor={msgValidacionClaveDobleFactor}
        setGeneracionExitosaClaveDobleFactor={
          setGeneracionExitosaClaveDobleFactor
        }
        setOpenModalGenerarClaveDobleFactor={
          setOpenModalGenerarClaveDobleFactor
        }
      />
    </>
  );
};
TransferenciasCuentasPrymeraPage.propTypes = {
  cuentasOperacionesPrymera: PropTypes.array.isRequired,
  loadingCuentasOperacionesPrymera: PropTypes.bool.isRequired,
  getCuentasOperacionesPrymera: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  loadingDisponibilidadPago: PropTypes.bool.isRequired,
  transferenciaCuentasPrymeraValidar: PropTypes.func.isRequired,
  transferenciaCuentasPrymeraConfirmar: PropTypes.func.isRequired,
  loadingTransferenciaCuentasPrymeraValidar: PropTypes.bool.isRequired,
  loadingTransferenciaCuentasPrymeraConfirmar: PropTypes.bool.isRequired,
  generarClaveDobleFactor: PropTypes.func.isRequired,
  validarClaveDobleFactor: PropTypes.func.isRequired,
  claveDobleFactorUsuario: PropTypes.object,
  loadingGenerarClaveDobleFactor: PropTypes.bool.isRequired,
  loadingValidarClaveDobleFactor: PropTypes.bool.isRequired,
};
export default connect(mapState, actions)(TransferenciasCuentasPrymeraPage);
